module.exports = __webpack_public_path__ + "static/WhenThePastWasAround2-a43c968181e54c964e53374111d1fdb0.png";